module.exports = __webpack_public_path__ + "static/media/email-br.87659419.png";